require('./cardStatementsTableRow.scss');

const PropTypes = require('prop-types');

// @ vendor
const React = require('react');
const { connect } = require('react-redux');
const { Link } = require('react-router-dom');
const classNames = require('classnames');
// @ components
const { OneLineSymbolAmount } = require('commonsComponents/oneLineSymbolAmount');
const { OKIconTask } = require('commonsComponents/OKIconTask');
const { OKTableCell } = require('commonsComponents/OKTableCell');
const { OKTableRow } = require('commonsComponents/OKTableRow');
const DateHelper = require('utilities/dateHelper');
const { formatAmountObject, getPlainAmountObject } = require('utilities/currencyHelper');
const { DATE_FORMAT } = require('constants/index');
// @ utilities
const { toFirstUppercase } = require('utilities/stringHelper');
//@core
const { getLanguage } = require('core/i18n').i18n;
// @ constants

const {
    CARD_STATEMENT_MONTHLY_EXTRACT,
} = require('constants/index');

class CardStatementsTableRow extends React.Component {

    render() {
        const {
            id,
            immScreen,
            immTransaction,
        } = this.props;

        const cardId = immTransaction.get('cardId');
        const date = DateHelper.formatDate(immTransaction.get('date'), DATE_FORMAT);
        const paymentMethod = toFirstUppercase(immTransaction.get('paymentMethod'));
        const statementId = immTransaction.get('id');
        const plainAmountObject = getPlainAmountObject(immTransaction.get('amount'));
        const isMobile = immScreen.get('isMobile');
        const rowIcon = (
            <OKIconTask
                activeHover={false}
                icon="icon-recibo"
                type="circle"
            />
        );
        const settlement = (
            <OneLineSymbolAmount
                amountObject={plainAmountObject}
                language={getLanguage()}
                amountObjectFormatted={formatAmountObject(plainAmountObject, true)}
            />
        );

        let destinationURL;
        let tableRow;

        if (immTransaction.get('type') === CARD_STATEMENT_MONTHLY_EXTRACT) {
            destinationURL = `/myprofile/cards/${cardId}/statement/${statementId}`;
        } else {
            destinationURL = `/myprofile/cards/${cardId}/statement/detail/${statementId}`;
        }

        const periodLinkClasses = classNames(
            {'card-statements-table-row__cell-period-label-mobile' : isMobile},
            {'card-statements-table-row__cell-period-label' : !isMobile}
        );

        const periodLink = (
            <Link
                to={destinationURL}
                className={periodLinkClasses}
            >
                {date}
            </Link>
        );

        if (isMobile) {
            tableRow = (
                <OKTableRow id={id}>
                    <OKTableCell className="card-statements-table-row__cell-icon-mobile">
                        {rowIcon}
                    </OKTableCell>
                    <OKTableCell>
                        <p className="card-statements-table-row__detail-mobile">
                            <span className="card-statements-table-row__cell-period-link">
                                {periodLink}
                            </span>
                        </p>
                        <p className="card-statements-table-row__detail-mobile">
                            {paymentMethod}
                        </p>
                        <p className="card-statements-table-row__detail-mobile card-statements-table-row__detail-mobile--margin-top">
                            {settlement}
                        </p>
                    </OKTableCell>
                </OKTableRow>
            );
        } else {
            tableRow = (
                <OKTableRow id={id}>
                    <OKTableCell className="card-statements-table-row__cell-period">
                        <span className="card-statements-table-row__cell-icon">
                            {rowIcon}
                        </span>
                        <span className="card-statements-table-row__cell-period-link">
                            {periodLink}
                        </span>
                    </OKTableCell>
                    <OKTableCell>
                        {paymentMethod}
                    </OKTableCell>
                    <OKTableCell className="card-statements-table-row__cell-settlement">
                        {settlement}
                    </OKTableCell>
                </OKTableRow>
            );
        }

        return tableRow;
    }
}

CardStatementsTableRow.propTypes = {
    id: PropTypes.string.isRequired,
    immScreen: PropTypes.object.isRequired,
    immTransaction: PropTypes.object.isRequired,
}

module.exports.constructor = CardStatementsTableRow;
module.exports = connect(
    state => ({
        immScreen: state.screen,
    }),
    null)(CardStatementsTableRow);
